import React, {Component} from 'react';
import styles from './styles.css';
import {observer} from 'mobx-react';
import ImposerStore from './ImposerStore';

import Page from './Page'

@observer
export default class Imposer extends Component {
  store = null;

  constructor() {
    super();
    this.store = new ImposerStore();

  }

  handleFileInputChange = e => this.store.addFiles(e.target.files);
  handleRemoveFile = (index) => this.store.removeFile(index);

  render() {
    console.log('RENDERING!');
    const {store, handleFileInputChange, handleRemoveFile} = this;
    return (
      <section>
        <h1>Imposer</h1>
        <p>
          <input type="file" onChange={handleFileInputChange} accept=".pdf" multiple/>
        </p>
        <div>
          {store.files.map((file, index) => {
            return (
              <div className={styles.fileContainer} key={index}>
                <h1>{file.name}</h1>
                <div className={styles.pagesContainer}>
                  {file.pages.map(page => {
                    return (
                      <Page key={page.pageIndex} page={page}/>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>

      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Imposer/Imposer.js